import { useSearchParams } from '@remix-run/react';
import cx from 'classnames';

import ArchiveSection from '~/pages/index/ArchiveSection';
import FeaturedSections from '~/pages/index/FeaturedSections';
import HeaderAdplacementSection from '~/pages/index/HeaderAdplacementSection';
import WidgetsSection from '~/pages/index/WidgetsSection';
import Hero from '~/pages/index/v2/Hero';

import BreakpointsContainer from '~/components/BreakpointsContainer';
import { Page } from '~/components/Layout';
import NotFound from '~/components/NotFound';

import type { HomePage } from '~/interfaces/home_page';

interface Props {
  homePage: HomePage;
  showExampleSite: boolean;
}

const HomePagev2 = ({ homePage, showExampleSite }: Props) => {
  const hasWidgetsEnabled = homePage?.widgets_section?.widgets_enabled?.length > 0;
  const archiveLayout = homePage?.posts_section?.archive.layout;
  const [searchParams] = useSearchParams();
  const path404 = searchParams.get('404');
  return (
    <Page bgColor={homePage.general_section.theme.bg_color}>
      {path404 ? (
        <NotFound path={path404} />
      ) : (
        <>
          <Hero />
          <HeaderAdplacementSection />
        </>
      )}
      <BreakpointsContainer>
        <FeaturedSections
          isNewWebBuilder={true}
          isExampleWebSite={showExampleSite}
          postsSection={homePage.posts_section}
          generalSection={homePage.general_section}
        />
      </BreakpointsContainer>

      <BreakpointsContainer className="pt-0">
        <div className="grid w-full grid-cols-12">
          <div
            className={cx({
              'order-last col-span-12 pb-4 pt-2 lg:order-first': true,
              'pr-0 lg:col-span-8 lg:pr-2': hasWidgetsEnabled,
              'mb-8': !hasWidgetsEnabled,
            })}
          >
            <ArchiveSection
              isNewWebBuilder={true}
              gridCols={hasWidgetsEnabled ? '2' : '3'}
              cardOrientation={archiveLayout === 'list' ? 'horizontal' : 'vertical'}
            />
          </div>

          {hasWidgetsEnabled && (
            <div className="col-span-12 pl-0 pr-0 pt-4 lg:col-span-4 lg:pl-8 lg:pt-8">
              <WidgetsSection isNewWebBuilder={true} />

              {/** Removing will break some enterprise user's programmatic ads */}
              <div id="side-panel-ad-placement" />
              {/*-------------------------------------------------------------*/}
            </div>
          )}
        </div>
      </BreakpointsContainer>
    </Page>
  );
};

export default HomePagev2;
